module.exports = __webpack_public_path__ + "static/media/AW_HP_FR_1757x1080_Lemonade.529db01b.mp4";